import React, { useContext } from 'react'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { Box, Container, Typography, useMediaQuery } from '@material-ui/core'
import FlexView from 'react-flexview/lib'
import PropTypes from 'prop-types'
import { CoveragesModification } from './CoveragesModification'
import { OwnerDetailsModification } from './OwnerSection/OwnerDetailsModification'
import { PolicyModificationContextStore } from '../../../context/PolicyModificationContext'
import { RiderDetailesModification } from './RiderDetailesModification'
import { MotorcyclesDetailsModification } from './MotorcycleSection/MotorcyclesDetailsModification'
import { OdometerDetailsModification } from './OdometerSection/OdometerDetailsModification'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    'aria-controls': `scrollable-force-tabpanel-${index}`,
  }
}

export const PolicyModification = () => {
  const isMobile = !useMediaQuery(theme => theme.breakpoints.up('md'))
  const [tabIndex, setTabIndex] = React.useState(0)
  const modifyContext = useContext(PolicyModificationContextStore)
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue)
  }

  const handleOnContinue = index => {
    setTabIndex(index + 1)
  }

  return (
    <Container maxWidth={'lg'} className="margin-top-basic">
      <Typography color="error">
        <b>
          {' '}
          *Before applying any change – make sure you have the new updated odometer readings per each motorcycle listed under the policy
        </b>
      </Typography>
      <FlexView hAlignContent={'center'}>
        <Tabs
          orientation={'horizontal'}
          variant="scrollable"
          value={tabIndex}
          indicatorColor={'primary'}
          textColor="primary"
          scrollButtons={isMobile ? 'on' : ''}
          onChange={handleTabChange}
        >
          <Tab label="Owner Details" {...a11yProps(0)} />
          <Tab label="Motorcycle Details" {...a11yProps(1)} disabled={!modifyContext.owner_detailes_saved} />
          <Tab label="Rider Details" {...a11yProps(2)} disabled={!modifyContext.motorcycles_details_saved} />
          <Tab label="Coverages" {...a11yProps(3)} disabled={!modifyContext.rider_details_saved} />
          {!modifyContext.isRenewal && <Tab label="Odometers" {...a11yProps(4)} disabled={!modifyContext.is_modify_finishs} />}
        </Tabs>
      </FlexView>
      <TabPanel value={tabIndex} index={0}>
        <OwnerDetailsModification onContinue={handleOnContinue} tabIndex={0} />
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <MotorcyclesDetailsModification onContinue={handleOnContinue} tabIndex={1} />
      </TabPanel>
      <TabPanel value={tabIndex} index={2}>
        <RiderDetailesModification onContinue={handleOnContinue} tabIndex={2} />
      </TabPanel>
      <TabPanel value={tabIndex} index={3}>
        <CoveragesModification onContinue={() => handleOnContinue(3)} />
      </TabPanel>
      {!modifyContext.isRenewal && (
        <TabPanel value={tabIndex} index={4}>
          <OdometerDetailsModification />
        </TabPanel>
      )}
    </Container>
  )
}
